import { render, staticRenderFns } from "./shop.edit.vue?vue&type=template&id=0107e3e8&scoped=true"
import script from "./shop.edit.vue?vue&type=script&lang=js"
export * from "./shop.edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0107e3e8",
  null
  
)

export default component.exports